import React from 'react'
import utils, { covertTimestampISO } from '../utils'
import { Link } from 'react-router'



interface SmallArticleProps {
	article: {
		article_path: string
		title: string
		created_at: string
		published_at?: string
		updated_at?: string
	} | Record<string, any>
}

function SmallArticleItem({ article }: SmallArticleProps) {
	return <Link
		to={article["updated_at"] ? `/${article["article_path"]}` : ''}
		className={
			'w-full flex flex-wrap articles-center justify-between py-1 border-t border-t-outline ' +
			(article["updated_at"] ? 'cursor-pointer' : 'cursor-default pointer-events-none')
		}
	>
		<div>
			<p>
				<span className='text-sm mr-2 font-semibold'>{utils.timeFromTimestamp(covertTimestampISO(article["created_at"]), true)}</span>
				<span className='text-sm text-primary'>{`/${article["article_path"]}`}</span>
			</p>
			<p className='text-xl font-semibold'>{article.title}</p>
			{article["published_at"] ?
				<span className='text-sm font-semibold text-radiationGreen'>Updated {utils.getLastOnline(covertTimestampISO(article["published_at"]))}</span> :
				<span className='text-sm font-semibold text-orange-500'>Draft</span>
			}
		</div>
	</Link>
}

export default SmallArticleItem